import { Chart } from "chart.js";
import theme from "../../components/styles/theme/theme";
import { Title } from "./chartOptions";

export const calculate = (chart: Chart, title?: Title) => {
  const { ctx } = chart;
  const indexPerDataSet = new Map<number, number>();
  const summaryPerIndex = new Map<number, number>();
  const isHorizontal = chart.options.indexAxis === "y";

  chart.data.datasets.forEach((dataset, datasetIndex) => {
    const { data } = chart.getDatasetMeta(datasetIndex);
    data.forEach((bar, barIndex) => {
      const barData = dataset.data[barIndex];
      if (barData) {
        const lastIndex = indexPerDataSet.get(barIndex) || -1;
        const summary = summaryPerIndex.get(barIndex) || 0;
        if (lastIndex < datasetIndex) {
          indexPerDataSet.set(barIndex, datasetIndex);
          summaryPerIndex.set(barIndex, summary + (barData as number));
        }
      }
    });
  });

  chart.data.datasets.forEach((dataset, datasetIndex) => {
    const { data } = chart.getDatasetMeta(datasetIndex);
    data.forEach((bar, barIndex) => {
      const barData = dataset.data[barIndex];
      if (barData) {
        const index = indexPerDataSet.get(barIndex);
        const summary = summaryPerIndex.get(barIndex);
        if (datasetIndex === index) {
          ctx.globalCompositeOperation = "destination-over";
          ctx.fillStyle = theme.palette.common.black;
          ctx.textAlign = "center";
          if (isHorizontal) {
            ctx.fillText(
              `${parseFloat(`${summary}`).toLocaleString("en")}`,
              bar.x + 25,
              bar.y + 4
            );
          } else {
            const prevSummaryPerIndex = summaryPerIndex.get(barIndex - 1);
            if (
              prevSummaryPerIndex &&
              summary &&
              title === "impact_over_time"
            ) {
              const percentageIncrease = (
                ((summary - prevSummaryPerIndex) / prevSummaryPerIndex) *
                100
              ).toFixed(1);
              const parsedValue = Number(percentageIncrease);

              const finalParsedValue = !!parsedValue
                ? `${parsedValue > 0 ? "+" : ""}${parsedValue}%`
                : null;

              finalParsedValue &&
                ctx.fillText(finalParsedValue, bar.x + 70, bar.y - 5);
            }
            ctx.fillText(
              `${parseFloat(`${summary}`).toLocaleString("en")}`,
              bar.x,
              bar.y - 5
            );
          }
          ctx.globalCompositeOperation = "source-over";
        }
      }
    });
  });

  summaryPerIndex.clear();
  indexPerDataSet.clear();
};
